import { Link } from 'react-router-dom';

import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { formatEUR } from '../../utils/money';
import { toneForGoalProgress } from '../../utils/goalDisplayUtils';
import { cn } from '../../utils/cn';

const TONE_TEXT = {
  success: 'text-success-fg',
  sage: 'text-sage-on-tint',
  warning: 'text-warning-fg',
  danger: 'text-danger-fg',
};

const TONE_BAR = {
  success: 'bg-gradient-to-r from-success-500 to-success-700',
  sage: 'bg-gradient-to-r from-sage-500 to-sage-600',
  warning: 'bg-gradient-to-r from-warning-500 to-warning-700',
  danger: 'bg-gradient-to-r from-danger-500 to-danger-700',
};

const TONE_WORD_KEY = {
  success: 'toneDone',
  sage: 'toneOnTrack',
  warning: 'toneBehind',
  danger: 'toneUrgent',
};

/** ds/card/goal-focus no .pen — readout é sempre "o que falta", não a %. */
export function GoalFocusCard({ goal }) {
  const copy = pt.dashboard.goalFocus;
  const target = Number(goal.target_amount || 0);
  const accumulated = Number(goal.accumulated || 0);
  const pct = Number(goal.progress_pct || 0);
  const remaining = Math.max(0, target - accumulated);
  const tone = toneForGoalProgress(pct);

  return (
    <Link
      to={paths.goal(goal.id)}
      className="flex flex-col gap-space-3 rounded-ds-lg border border-border bg-card p-space-4 transition hover:bg-muted/50"
    >
      <div className="flex flex-col gap-space-1">
        <p className="type-section text-muted-foreground">{copy.eyebrow}</p>
        <p className="font-display text-type-display-metric font-bold tracking-[-0.017em] text-card-foreground">
          {copy.readout.replace('{amount}', formatEUR(remaining))}
        </p>
        <p className="text-type-body-sm font-semibold text-card-foreground">{goal.name}</p>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-track">
        <div
          className={cn('h-full rounded-full transition-[width]', TONE_BAR[tone])}
          style={{ width: `${Math.min(100, Math.max(0, pct))}%` }}
        />
      </div>
      <div className="flex items-center justify-between gap-space-2 text-type-label">
        <span className="font-normal text-muted-foreground">
          {copy.scaleLeft
            .replace('{accumulated}', formatEUR(accumulated))
            .replace('{target}', formatEUR(target))}
        </span>
        <span className={cn('font-semibold', TONE_TEXT[tone])}>
          {pct.toFixed(0)} % · {copy[TONE_WORD_KEY[tone]]}
        </span>
      </div>
    </Link>
  );
}

export default GoalFocusCard;
